import { REDUCE_POLICY_SUMMARY } from '../../constants/actions/policy';

export function reducePolicySummary(payload) {
    return {
        type: REDUCE_POLICY_SUMMARY,
        payload,
    };
}
